import mutationTypes from "./mutation-types";

const setRecordedVideo = ({ commit }, { videoFile, videoName }) => {
    commit(mutationTypes.SET_VIDEO_FILE, videoFile);
    commit(mutationTypes.SET_VIDEO_NAME, videoName);
};

const setUserData = ({ commit }, userData) => {
    commit(mutationTypes.SET_USER_DATA, userData);
};

export default {
    setRecordedVideo,
    setUserData
};
